const petsActionTypes = {
  addPet: 'pets/addPet',
  removePet: 'pets/removePet',
};

export default petsActionTypes;
